import {
    CGSkills,
    videoPlayerTutorial
} from "./components/common/CoursePassingProcessClass";

import CourseWebsiteProcessMain from "./course/courseWebsiteProcessMain";
import {
    progressBar,
    collapseCompletedModule
} from "./components/common/Main";
import ToggleAccordion from "./components/website/ToggleAccordion";
import TableAccordion from "./components/common/TableAccordion";
import LearningModeSelect from './components/common/LearningModeSelect';
import CourseOutlineModeFilter from './components/website/CourseOutlineModeFilter';

window.addEventListener('DOMContentLoaded', () => {
    CGSkills.openPopup();
    CGSkills.CGContentEvents();
    CGSkills.iDontKnowButton();
    CGSkills.notificationButtons();
    videoPlayerTutorial.init();
    progressBar();
    collapseCompletedModule();

    new ToggleAccordion();

    // Course outline: the module rows are the accordion. `collapseCompletedModule()` above stays for
    // the old tables — the matrix carries no `.collapse-table`, so the two never fire on one click.
    new TableAccordion();

    // Learning mode: the same picker the LMS uses, but the pick only blanks outline columns here --
    // there is no learner to save it for, so nothing is persisted.
    new LearningModeSelect();
    new CourseOutlineModeFilter();

    // Override the public assessment runner so website visitors can take all assessment types.
    const courseWebsiteProcessMain = new CourseWebsiteProcessMain();
    window.publicAssessmentRunner = courseWebsiteProcessMain.getPublicAssessmentRunner();

    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    };

    const getCookie = (name) => {
        const target = name + "=";
        const decoded = decodeURIComponent(document.cookie);
        const parts = decoded.split(';');
        for (let i = 0; i < parts.length; i++) {
            let c = parts[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(target) === 0) {
                return c.substring(target.length, c.length);
            }
        }
        return "";
    };

    const markLessonCompleteUI = (topicId) => {
        setCookie(`tutorial_${topicId}`, 'completed', 7);
        const row = document.querySelector(`.course-topic-row[data-id="${topicId}"]`);
        if (!row) return;

        // Tutorial cell
        const tdTutorial = row.querySelector('.td-tutorial');
        if (tdTutorial) {
            const lessonType = row.dataset.lessonType || row.dataset.rowTutorialType || row.dataset.rowLessonType;
            // If it's an editor lesson, keep existing link/href and just update label/bullet
            if (lessonType === '3') {
                const existingLink = tdTutorial.querySelector('a');
                if (existingLink) {
                    existingLink.innerHTML = '<i class="bullet __green"></i><span>Complete</span>';
                    existingLink.classList.add('course-status');
                } else {
                    // Fallback: create a non-navigating indicator
                    tdTutorial.innerHTML = '<span class="course-status"><i class="bullet __green"></i><span>Complete</span></span>';
                }
            } else {
                tdTutorial.innerHTML = '';
                const a = document.createElement('a');
                a.href = '#';
                a.className = 'course-status js-video-popup';
                a.dataset.type = 'tutorial';
                if (row.dataset.wbt) a.dataset.video = row.dataset.wbt;
                if (row.dataset.width && row.dataset.height) {
                    a.dataset.size = `${row.dataset.width}x${row.dataset.height}`;
                }
                a.innerHTML = '<i class="bullet __green"></i><span>Complete</span>';
                tdTutorial.appendChild(a);
            }
        }

        // Post cell unlock
        const tdPost = row.querySelector('.td-post');
        if (tdPost) {
            const ia = row.dataset.ia;
            const assessType = row.dataset.assessmentType || row.dataset.rowAssessmentType || '';
            const parentAssessId = row.dataset.parentAssessId || row.dataset.rowParentAssessment || '';
            const prePassed = getCookie(`pre_${topicId}`) === 'pass';
            const postCookie = getCookie(`post_${topicId}`);
            const postLink = document.createElement('a');
            postLink.href = '#';
            postLink.className = 'course-status';

            if (ia) {
                postLink.classList.add('js-video-popup');
                postLink.dataset.type = 'post';
                postLink.dataset.video = ia;
                if (row.dataset.width && row.dataset.height) {
                    postLink.dataset.size = `${row.dataset.width}x${row.dataset.height}`;
                }
            } else if (assessType) {
                postLink.classList.add('js-public-assessment');
                postLink.dataset.stage = 'post';
                postLink.dataset.assessmentType = assessType;
                postLink.dataset.topicId = topicId;
                if (parentAssessId) postLink.dataset.parentAssessId = parentAssessId;
            }

            if (postCookie === 'pass') {
                postLink.innerHTML = '<i class="bullet __green"></i><span>Pass</span>';
            } else if (prePassed) {
                postLink.innerHTML = '<i class="bullet __green"></i><span>(Pass)</span>';
            } else {
                postLink.innerHTML = '<i class="bullet __gray"></i><span>Not Started</span>';
            }
            tdPost.innerHTML = '';
            tdPost.appendChild(postLink);
        }

        // Highlight row to reflect completion
        row.classList.add('__light-green-bg');
    };

    const openPostForTopic = (topicId) => {

        // Mark tutorial complete in DOM
        markLessonCompleteUI(topicId);

        const row = document.querySelector(`.course-topic-row[data-id="${topicId}"]`);
        if (!row) return;

        const postStatus = getCookie(`post_${topicId}`);
        if (postStatus === 'pass') {
            return;
        }

        // Find a clickable post assessment link (captivate or interactive)
        const postLink = row.querySelector('.td-post a.js-video-popup, .td-post a.js-public-assessment, .td-post a.run-assessment');
        if (postLink) {
            setTimeout(() => postLink.click(), 300);
        }
    };

    // Auto-open post assessment when a lesson tab reports completion.
    window.addEventListener('message', (event) => {
        const data = event.data || {};
        if (data.type !== 'lessonComplete' || !data.topicId) return;
        openPostForTopic(data.topicId);
    });

    // If lesson was completed in same tab (fallback), check sessionStorage and open post.
    try {
        const completedId = sessionStorage.getItem('lessonCompleteTopic');
        if (completedId) {
            sessionStorage.removeItem('lessonCompleteTopic');
            openPostForTopic(completedId);
        }
    } catch (e) {}
});
